import * as React from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import * as faIcon from "@fortawesome/free-solid-svg-icons";

export function CheckMark({checked}:{checked:boolean}) {
    return <span style={{paddingLeft: 5}}><FontAwesomeIcon icon={checked?faIcon.faCheck:faIcon.faTimes}  /> </span>;
}